import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import Card from "../../../../common/Card"
import PannelHeader from "../../../../fragments/PannelHeader"
import PannelBody from "../../../../fragments/PannelBody"
import RelatedPatientItem from "./RelatedPatientItem"
import Subtitle from "../../../../fragments/Subtitle"
import FindRelatedPatients from "./FindRelatedPatients"
import { useUserTabEditPermissionDisabled } from "../../../../../lib/usersPermissions"
import SugestedPatients from "./SugestedPatients"

const RelatedPatients = ({showSugestedPatients, readOnly}) => {
    let userPermissionDisabled = useUserTabEditPermissionDisabled('related_patients_edit')
    const activeCase = useSelector(state => state.case.activeCase)    

    const [data, setData] = useState(null)

    useEffect(() => {
        if (activeCase && activeCase.related_patients) {
            
            let arr = [...activeCase.related_patients]

            if (arr) {
                setData(arr)
            }             
        }

        
    }, [activeCase])

    return <Card>
        <PannelHeader>
            <div className="flex-vertical-center">
                <div>
                    <h2>Related Patients</h2>
                    <Subtitle>Patients Treating With</Subtitle>
                </div>
                <FindRelatedPatients permission={userPermissionDisabled} readOnly={readOnly} />
            </div>            
        </PannelHeader>
        <PannelBody>
            {data && data.length > 0 && data.map(item => (
                <RelatedPatientItem key={item.id} data={item} permission={userPermissionDisabled} readOnly={readOnly} />
            ))}
            
            {(!data || data.length == 0) && <p>Patient has no related cases.</p>}
        </PannelBody>
        {showSugestedPatients && 
            <SugestedPatients readOnly={readOnly} />
        }
    </Card>
}

export default RelatedPatients